// src/components/badge/badge.js
import React from "react";
import { Badge } from "antd";
import "./badge.css";

function AppBadge({ count = 0, showDot = false, title, children, className = "" }) {
  // Hide badge if no count and no dot
  if (!showDot && count === 0) {
    return children || null;
  }

  return (
    <Badge count={!showDot ? count : null} dot={showDot} title={title} className={`app-badge ${className}`}>
      {children}
    </Badge>
  );
}

export default AppBadge;
